import { render, staticRenderFns } from "./AboutComplex.vue?vue&type=template&id=58320f01&"
import script from "./AboutComplex.vue?vue&type=script&lang=ts&"
export * from "./AboutComplex.vue?vue&type=script&lang=ts&"
import style0 from "./AboutComplex.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
